import { Injectable } from "@angular/core";
import { from, Observable, Observer, of } from "rxjs";
import { disconnect } from '@wagmi/core'
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { Web3Modal } from '@web3modal/html'
import { configureChains, createConfig } from '@wagmi/core';
import { environment } from "environments/environment";
import { wagmiNetwork } from "app/services/web3/web3.config";


const projectId = 'dd7646c2f0032eaeeaf0540f0ccbb92d'


@Injectable({
    providedIn: 'root'
})
export class WalletconnectWrapperService {


    connect(): Observable<any> {
        modal.openModal()
        return new Observable((observer: Observer<any>) => {
            observer.next(modal)
            observer.complete();
        });
    }


    disconnectProvider(): Observable<any> {
        return from(disconnect());
    }
}

const getChains = (): any[] => {
    //due to bug with some connector just 1 chain is allowed in array
    //type of chains const chains = [/* bsc,  */bscTestnet]
    let chains = [];
    chains.push(wagmiNetwork[environment.allowedNetwork[0]]);
    return chains;
}
const chains = getChains();

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])
const wagmiConfig = createConfig({
    autoConnect: true,
    connectors: w3mConnectors({ projectId, chains }),
    publicClient
})
const ethereumClient = new EthereumClient(wagmiConfig, chains)
const modal = new Web3Modal(
    {
        projectId,
        themeVariables: { '--w3m-z-index': '1100' },
        mobileWallets: [{
            id: 'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
            name: 'Metamask',
            links: {
                native: 'https://metamask.io/',
                universal: 'https://metamask.io/'
            }
        }]
    },
    ethereumClient);

const getRpcMapProviderOption = (): { [key in number]: string } => {
    /* type of return:
    56: "https://bsc-dataseed.binance.org",
    97: "https://data-seed-prebsc-1-s1.binance.org:8545/" */
    return {
        [chains[0].id]: chains[0].rpcUrls.default.http
    }
}

export const getProviderOption = (): any => {
    return {
        projectId: projectId,
        chains: [chains[0].id], // REQUIRED chain ids
        // optionalChains, // OPTIONAL chains
        showQrModal: false, // REQUIRED set to "true" to use @walletconnect/modal
        // methods, // REQUIRED ethereum methods
        // optionalMethods, // OPTIONAL ethereum methods
        // events, // REQUIRED ethereum events
        // optionalEvents, // OPTIONAL ethereum events
        rpcMap: getRpcMapProviderOption(),
        // metadata: {
        //     name: "Trainer Hub",
        //     description: "Kryptomon Trainer Hub",
        //     url: "https://my-dapp.com",
        //     icons: ["https://my-dapp.com/logo.png"],
        // },
    }
}